<template>
  <section class="c-section c-section--service-single">
    <div v-if="context.post" class="c-banner">
      <figure class="c-banner__figure">
        <img :src="context.post.banner_fondo" class="h-100 w-100 of--cover" alt="">
      </figure>
      <div class="c-banner__figcaption">
        <h1 class="c-banner__title">{{context.post.post_title}}</h1>
        <h4 class="c-banner__subtitle">{{context.post.subtitulo}}</h4>
      </div>
    </div>
    <div v-if="context.post" class="container">
      <div class="c-content" v-html="context.post.content">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      context: {},
      contextLoading: true,
    };
  },
  created() {
    this.getFullContext({ type: 'post-type', typeName: 'service', slug: this.$route.params.slug });
  },
  watch: {
    contextLoading(state) {
      if (!state) {
        if (document) document.title = `${this.context.post.title} - Agro Club`;

        window.setTimeout(() => {
          this.loadScripts();
        }, 100);
      }
    },
  },
  methods: {
    loadScripts() {
      const tiktokScript = document.createElement('script');
      const twitterScript = document.createElement('script');

      tiktokScript.setAttribute('src', 'https://www.tiktok.com/embed.js');
      twitterScript.setAttribute('src', 'https://platform.twitter.com/widgets.js');

      document.head.appendChild(tiktokScript);
      document.head.appendChild(twitterScript);
    },
  },
};
</script>
